import React from 'react';
import PropTypes from 'prop-types'
import { MicroFEComponent, MicroFEShell } from '@carvana/microfrontend';
import Header from './Header';
import {
  LayoutWrapper,
} from './Layout.styles'
import { GlobalStyle } from '../MySpinView/MySpinView.styles';

const headerModule = [
  'HeaderModule',
  [
    {
      component: 'default',
      core: true,
      default: {
        file: 'index.js',
        manifest: `${
          process.env.CARVANA_APP_ASSETS_URL
        }/header/module/assets-manifest.json?v=${Date.now()}`,
      },
    },
  ],
];

const footerModule = [
  'FooterModule',
  [
    {
      component: 'default',
      core: true,
      default: {
        file: 'index.js',
        manifest: `${
          process.env.CARVANA_APP_ASSETS_URL
        }/footer/module/assets-manifest.json?v=${Date.now()}`,
      },
    },
  ],
];

const shellConfig = {
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    'prop-types': () => import('prop-types'),
    PropTypes: () => import('prop-types'),
    styled: () => import('styled-components'),
  },
  files: [headerModule, footerModule],
};

const Layout = ({ children }) => (
  <MicroFEShell
    config={shellConfig}
    env={process.env.CARVANA_APP_ENVIRONMENT}
    name="carvana-mobile-capture-share"
  >
    <div
      data-qa="app-title" // required for nginx tests
      alt="Mobile Capture Booth" // required for nginx tests
    >
      <LayoutWrapper>
        <GlobalStyle />
        <Header />
        {children}
        <MicroFEComponent id="default" module="FooterModule">
          {({ Component: FooterComponent }) => (
            <FooterComponent
              environment={process.env.CARVANA_APP_ENVIRONMENT}
              isPartner={false}
            />
          )}
        </MicroFEComponent>
      </LayoutWrapper>
    </div>
  </MicroFEShell>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
